// Layout
import LayoutAdmin from '../layouts/LayoutAdmin';
import LayoutBasic from '../layouts/LayoutBasic';

// Admin Pages
import AdminHome from '../pages/Admin';
import AdminSignIn from '../pages/Admin/SignIn';
import AdminUsers from '../pages/Admin/Users';
import AdminPublication from '../pages/Admin/Publication';
import AdminNewPublication from '../pages/Admin/Publication/NewPublication';
import AdminComments from '../pages/Admin/Comment';
import AdminSubCategory from '../pages/Admin/SubCategory';
import AdminNotes from '../pages/Admin/ReleaseNotes';

// Pages
import Home from '../pages/Home';
import Search from '../pages/Search';
import ReleaseNotes from '../pages/ReleaseNotes';
import Publications from '../pages/Publications';
import Support from '../pages/Support';
import TermsAndConditions from '../pages/TermsAndConditions';

// Others
import Error404 from '../pages/Error404';

const routes = [
    {
        path: '/admin',
        component: LayoutAdmin,
        exact: false,
        routes: [
            {
                path: '/admin',
                component: AdminHome,
                exact: true
            },
            {
                path: '/admin/login',
                component: AdminSignIn,
                exact: true
            },
            {
                path: '/admin/users',
                component: AdminUsers,
                exact: true
            },
            {
                path: '/admin/publication',
                component: AdminPublication,
                exact: true
            },
            {
                path: '/admin/new_publication',
                component: AdminNewPublication,
                exact: true
            },
            {
                path: '/admin/comment',
                component: AdminComments,
                exact: true
            },
            {
                path: '/admin/subcategory',
                component: AdminSubCategory,
                exact: true
            },
            {
                path: '/admin/notes',
                component: AdminNotes,
                exact: true
            },
            {
                component: Error404
            }
        ]
    },
    {
        path: '/',
        component: LayoutBasic,
        exact: false,
        routes: [
            {
                path: '/',
                component: Home,
                exact: true
            },
            {
                path: '/search',
                component: Search,
                exact: true
            },
            {
                path: '/search/:data/:id_cat/:id_sub',
                component: Search,
                exact: true
            },
            {
                path: '/search/:url',
                component: Search,
                exact: true
            },
            {
                path: '/releasenotes',
                component: ReleaseNotes,
                exact: true
            },
            {
                path: '/releasenotes/:url',
                component: ReleaseNotes,
                exact: true
            },
            {
                path: '/publications',
                component: Publications,
                exact: true
            },
            {
                path: '/publications/:url',
                component: Publications,
                exact: true
            },
            {
                path: '/support',
                component: Support,
                exact: true
            },
            {
                path: '/termsandconditions',
                component: TermsAndConditions,
                exact: true
            },
            {
                component: Error404
            }
        ]
    }
]

export default routes;